var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    attrs: {
      id: "agreement"
    }
  }, [_c("a-form-model", {
    ref: "dataForm",
    attrs: {
      model: _vm.dataForm
    }
  }, [_c("a-tabs", {
    staticStyle: {
      "margin-top": "24px",
      "margin-bottom": "10px"
    },
    attrs: {
      type: "card"
    },
    on: {
      change: _vm.tabChange
    },
    model: {
      value: _vm.tabKey,
      callback: function callback($$v) {
        _vm.tabKey = $$v;
      },
      expression: "tabKey"
    }
  }, [_vm._l(_vm.dataForm.dataList, function (item, index) {
    return [_c("a-tab-pane", {
      key: index,
      attrs: {
        tab: item.languageName
      }
    })];
  })], 2), _vm.dataForm.dataList[_vm.tabKey] && _vm.dataForm.dataList[_vm.tabKey].list ? [_vm._l(_vm.dataForm.dataList[_vm.tabKey].list, function (item) {
    return [_c("a-form-model-item", [_c("div", {
      staticClass: "agreement"
    }, [item.agreementType == 0 ? [_vm._v(" " + _vm._s(_vm.$t("basicSettings.registerProtocol")) + ": "), _c("tinymce-editor", {
      attrs: {
        id: "0"
      },
      on: {
        handleImgUpload: _vm.imgUpload,
        onClick: function onClick($event) {
          return _vm.showFYBtn(item);
        }
      },
      model: {
        value: item.agreementContent,
        callback: function callback($$v) {
          _vm.$set(item, "agreementContent", $$v);
        },
        expression: "item.agreementContent"
      }
    }), _c("a-tooltip", [_c("template", {
      slot: "title"
    }, [_vm._v(" " + _vm._s(_vm.$t("publicuse.translate")) + " ")]), item.showFY ? _c("img", {
      staticClass: "imageBtn",
      attrs: {
        src: _vm.fanyiPic,
        alt: ""
      }
    }) : _vm._e()], 2)] : _vm._e()], 2)]), _c("a-form-model-item", [_c("div", {
      staticClass: "agreement"
    }, [item.agreementType == 1 ? [_vm._v(" " + _vm._s(_vm.$t("basicSettings.shoppingTerms")) + ": "), _c("tinymce-editor", {
      attrs: {
        id: "1"
      },
      on: {
        handleImgUpload: _vm.imgUpload,
        onClick: function onClick($event) {
          return _vm.showFYBtn(item);
        }
      },
      model: {
        value: item.agreementContent,
        callback: function callback($$v) {
          _vm.$set(item, "agreementContent", $$v);
        },
        expression: "item.agreementContent"
      }
    }), _c("a-tooltip", [_c("template", {
      slot: "title"
    }, [_vm._v(" " + _vm._s(_vm.$t("publicuse.translate")) + " ")]), item.showFY ? _c("img", {
      staticClass: "imageBtn",
      attrs: {
        src: _vm.fanyiPic,
        alt: ""
      }
    }) : _vm._e()], 2)] : _vm._e()], 2)]), _c("a-form-model-item", [_c("div", {
      staticClass: "agreement"
    }, [item.agreementType == 3 ? [_vm._v(" " + _vm._s(_vm.$t("basicSettings.privacyPolicy")) + ": "), _c("tinymce-editor", {
      attrs: {
        id: "3"
      },
      on: {
        onClick: function onClick($event) {
          return _vm.showFYBtn(item);
        }
      },
      model: {
        value: item.agreementContent,
        callback: function callback($$v) {
          _vm.$set(item, "agreementContent", $$v);
        },
        expression: "item.agreementContent"
      }
    }), _c("a-tooltip", [_c("template", {
      slot: "title"
    }, [_vm._v(" " + _vm._s(_vm.$t("publicuse.translate")) + " ")]), item.showFY ? _c("img", {
      staticClass: "imageBtn",
      attrs: {
        src: _vm.fanyiPic,
        alt: ""
      }
    }) : _vm._e()], 2)] : _vm._e()], 2)])];
  })] : _vm._e()], 2), _c("footer-tool-bar", [_c("a-button", {
    attrs: {
      type: "primary",
      loading: _vm.loadingSave
    },
    on: {
      click: _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t("publicuse.save")))])], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };